import { isExternalUrl } from './is-external-link';

type LinkProps = {
  as: React.ElementType;
  target?: string;
  rel?: string;
  href: string;
  onClick?: (event: React.MouseEvent) => void;
};

type ButtonProps = {
  as: 'button';
  onClick: (event: React.MouseEvent) => void;
};

export const getLinkOrButtonProps = (
  onClick?: (e: React.MouseEvent) => void,
  href?: string,
  linkAs?: React.ElementType,
): LinkProps | ButtonProps => {
  if (href) {
    const external = isExternalUrl(href);

    // Using the `linkAs` prop to determine the type of link
    // If `linkAs` is provided, it will be used as the component type
    // If `linkAs` is not provided, it will default to 'a'
    if (!external && linkAs) {
      return {
        as: linkAs as React.ElementType,
        onClick: (event: React.MouseEvent) => {
          if (onClick) {
            onClick(event);
          }
        },
      } as LinkProps;
    }
    return {
      as: 'a',
      target: '_blank',
      rel: 'noopener noreferrer',
      href,
      onClick: (event: React.MouseEvent) => {
        if (onClick) {
          onClick(event);
        }
      },
    };
  }
  return {
    as: 'button',
    onClick: onClick || (() => {}),
  };
};
